import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi, DataForPatchingIdentity } from 'api/ApplicationDataApi';

import { ErrorResponse } from './ErrorResponse';

export const createIdentityDataThunk = (api: ApplicationDataApi) =>
  createAsyncThunk('/application/identity', async (data: DataForPatchingIdentity, thunkApi) => {
    try {
      return await api.patchIdentity(data);
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);

      throw error;
    }
  });
